import React, {memo} from 'react';
import './Comment.less';

export const Comment = memo(({text}) => {
	return <div className="comment">{text}</div>
})
